import { Platform } from 'react-native';

// DocumentPicker copies sources into app-private file:// cache paths. Prepare
// those paths for Android's multipart reader, as clipboard images already do.
export async function prepareAndroidUploadFile(file) {
  if (Platform.OS !== 'android' || !file?.uri?.startsWith('file://')) return file;
  const FileSystem = await import('expo-file-system');
  if (typeof FileSystem.getInfoAsync === 'function') {
    const info = await FileSystem.getInfoAsync(file.uri).catch(() => null);
    if (!info?.exists || info.isDirectory) {
      const error = new Error('This file could not be read. Select it again and retry the upload.');
      error.code = 'UPLOAD_FILE_UNREADABLE';
      throw error;
    }
  }
  // Preserve operation on older installed module sets that lack this helper.
  if (typeof FileSystem.getContentUriAsync !== 'function') return file;
  try {
    const uri = await FileSystem.getContentUriAsync(file.uri);
    return typeof uri === 'string' && uri.startsWith('content://') ? { ...file, uri } : file;
  } catch {
    return file;
  }
}
